import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  invalid?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { className, invalid, ...rest },
  ref,
) {
  return (
    <input
      ref={ref}
      className={cn(
        // DS: border 1.5px + sombra sutil 1px; focus com ring accent 15%.
        'h-10 w-full rounded-md bg-elevated border-[1.5px] px-3 text-sm text-text placeholder:text-text-muted',
        'shadow-[0_1px_2px_rgba(0,0,0,0.04)]',
        'transition-[border-color,box-shadow] focus:outline-none',
        invalid
          ? 'border-danger focus:shadow-[0_0_0_3px_rgba(192,57,43,0.15),0_1px_3px_rgba(0,0,0,0.05)]'
          : 'border-border2 hover:border-[var(--text-muted)] focus:border-[var(--accent)] focus:shadow-[0_0_0_3px_rgba(233,106,69,0.15),0_1px_3px_rgba(0,0,0,0.05)]',
        'disabled:opacity-60 disabled:cursor-not-allowed',
        className,
      )}
      {...rest}
    />
  );
});
